// Read fresh each time: the OS/laptop timezone can change while the app is
// open, and the browser picks that up without a reload.
export const getBrowserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export const timezone = getBrowserTimezone();
